import {
  isHlsMediaType,
  parseMediaTypeString
} from "./chunk-PDD4MAGE.js";

// src/adapter/hlsjs/is-supported.js
function getMediaSource(preferManagedMediaSource = true) {
  if (typeof self === "undefined")
    return void 0;
  const mms = (preferManagedMediaSource || !self.MediaSource) && self.ManagedMediaSource;
  return mms || self.MediaSource || self.WebKitMediaSource;
}
function mimeTypeForCodec(codec, type) {
  return `${type}/mp4;codecs="${codec}"`;
}
function getSourceBuffer() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function isMSESupported() {
  const mediaSource = getMediaSource();
  if (!mediaSource) {
    return false;
  }
  const sourceBuffer = getSourceBuffer();
  return !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === "function" && typeof sourceBuffer.prototype.remove === "function";
}
function isSupported() {
  if (!isMSESupported()) {
    return false;
  }
  const mediaSource = getMediaSource();
  return typeof mediaSource?.isTypeSupported === "function" && (["avc1.42E01E,mp4a.40.2", "av01.0.01M.08", "vp09.00.50.08"].some(
    (codecsForVideoContainer) => mediaSource.isTypeSupported(
      mimeTypeForCodec(codecsForVideoContainer, "video")
    )
  ) || ["mp4a.40.2", "fLaC"].some(
    (codecForAudioContainer) => mediaSource.isTypeSupported(
      mimeTypeForCodec(codecForAudioContainer, "audio")
    )
  ));
}

// src/adapter/hlsjs/can-play-type.ts
function canPlayType(mediaType) {
  const type = typeof mediaType === "string" ? parseMediaTypeString(mediaType) : mediaType;
  return !!type && isHlsMediaType(type) && isSupported();
}

export {
  canPlayType
};
